<div class="limiter">
  <div class="content-container wrapper">
    <div class="left">
      <div class="left-container">
        <span [ngClass]="titleClasses" class="title mb16" [style.height.px]="defaultTitleHeight"> {{ title }} </span>
        <p [ngClass]="textClasses" class="text">{{ text }}</p>
        <a class="transition-container td-n" [routerLink]="[transitionLink]">
          <span class="transition" [ngClass]="textColorClass">{{transitionName}}</span>
          <svg [icon]="icons.ArrowRight" class="svg24" [ngClass]="textColorClass" />
        </a>

        <div class="button-container mt24">
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <mat-icon [svgIcon]="iconName" class="icon"></mat-icon>
  </div>
</div>
